export class URLParser {

    static getOrganisationId(url: string): string {
        let urlOrgId = '';
        if (url[0] === '/') {
            url = url.substring(1);
        }
        const fragments = url.split('/');
        urlOrgId = fragments[0];
        return urlOrgId;
    }


}
